import * as React from 'react';
import {
  FooterWrapper, FooterContent, GobLogoLink, FooterColumnWrapper, FooterTitle,
  HorizontalWrapper, SocialText, IconWrapper, LocationTextWrapper, HorizontalWrapperTop,
  MailText, Link
} from './Footer.s';
import { SectionContent } from '@components/Sections/Sections.s';
import { GobLogo } from '@components/GobLogo/GobLogo';
import { LocationPin, Facebook, Twitter, Instagram, Mail } from '@components/Icons';

export const Footer = () => (
  <FooterWrapper>
    <SectionContent>
      <FooterContent>
        <GobLogoLink href='https://www.gobelins.fr/'>
          <GobLogo height={200} width={200} />
        </GobLogoLink>
        <FooterColumnWrapper>
          <FooterTitle>Contactez-nous</FooterTitle>
          <HorizontalWrapperTop>
            <IconWrapper>
              <LocationPin width={20} height={20} />
            </IconWrapper>
            <LocationTextWrapper>
              Start. &amp; co<br/>26 Rue du Dr Magnan<br/>75013 Paris
            </LocationTextWrapper>
          </HorizontalWrapperTop>
          <HorizontalWrapper>
            <IconWrapper>
              <Mail width={20} height={20} />
            </IconWrapper>
            <MailText>
              contact@start.com
            </MailText>
          </HorizontalWrapper>
        </FooterColumnWrapper>
        <FooterColumnWrapper>
          <FooterTitle>Retrouvez-nous</FooterTitle>
          <HorizontalWrapper>
            <Link href='https://twitter.com/startapp_paris' >
              <IconWrapper>
                <Twitter width={20} height={20} />
              </IconWrapper>
              <SocialText>
                Twitter
              </SocialText>
            </Link>
          </HorizontalWrapper>
          <HorizontalWrapper>
            <IconWrapper>
              <Facebook width={20} height={20} />
            </IconWrapper>
            <SocialText>Facebook</SocialText>
          </HorizontalWrapper>
          <HorizontalWrapper>
            <IconWrapper>
              <Instagram width={20} height={20} />
            </IconWrapper>
            <SocialText>Instagram</SocialText>
          </HorizontalWrapper>
        </FooterColumnWrapper>
      </FooterContent>
    </SectionContent>
  </FooterWrapper>
);



// WEBPACK FOOTER //
// src/app/src/components/Footer/Footer.tsx